import validate from "/builds/sgdf/projets-benevoles/digiform/front/node_modules/.pnpm/nuxt@4.6.4_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7_supports-color@10.2.2___@_af99d723357c7d1fb93bffffb932acfa/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45global from "/builds/sgdf/projets-benevoles/digiform/front/webapp/middleware/redirect.global.ts";
import manifest_45route_45rule from "/builds/sgdf/projets-benevoles/digiform/front/node_modules/.pnpm/nuxt@4.6.4_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7_supports-color@10.2.2___@_af99d723357c7d1fb93bffffb932acfa/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "participants-redirect": () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/middleware/participants-redirect.ts")
}